import React from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import { useDownloadPortabilityFile } from './hooks/useDownloadPortabilityFile';
import CustomDialog from 'widgets/component/CustomDialog';
import DownloadPortabilityForm from './components/DownloadPortabilityForm';
import {
  downloadPortabilityFileStorageAction,
  downloadPortabilityFileSFTPAction,
} from '_models/redux/download-portability-files/action';

const PageDownloadPortabilityFiles = ({
  downloadPortabilityFileStorageAction,
  downloadPortabilityFileSFTPAction,
  downloadPortabilityFile,
}) => {
  const {
    onSubmit,
    isDialogOpen,
    dialogMessage,
    handleClose,
    errorMessage,
    loading,
    processCompleted,
    setProcessCompleted,
    titleDialog,
  } = useDownloadPortabilityFile({
    downloadPortabilityFileStorageAction,
    downloadPortabilityFileSFTPAction,
    downloadPortabilityFile,
  });

  return (
    <>
      <Grid>
        <h3>Descargar archivos de portabilidad</h3>
      </Grid>
      <hr />
      <Grid container marginBottom={4}>
        <DownloadPortabilityForm
          onSubmit={onSubmit}
          loading={loading}
          processCompleted={processCompleted}
          setProcessCompleted={setProcessCompleted}
          errorMessage={errorMessage}
        />
      </Grid>
      <hr />

      <CustomDialog
        title={titleDialog}
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  downloadPortabilityFile: state?.downloadPortabilityFile,
});

const mapDispatchToProps = {
  downloadPortabilityFileStorageAction,
  downloadPortabilityFileSFTPAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageDownloadPortabilityFiles);
